<div class="terms-conditions-modal">
	<div class="dialog-content">
		<div class="t-c-icon">
			<img src="./assets/images/svgs/legal-terms-conditions.svg">
		</div>
		<div class="title">
			We’ve updated our terms & conditions
		</div>
		<!--  <div class="desc">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Non lacinia amet .
        </div> -->
		<div class="legal-documents">
			<div class="flex justify-center items-center"
				[innerHtml]="docxHtml?.changingThisBreaksApplicationSecurity?.content">
				<app-loading></app-loading>
			</div>
		</div>
		<div class="checkbox-t-c-documents">
			<label nz-checkbox [(ngModel)]="accept" (ngModelChange)="OnDocumentCheck()">
				I agree to the Terms and Conditions stated above
			</label>
		</div>
		<div *ngIf="errorMessage">
			<app-custom-error-display [errorMessage]="errorMessage"></app-custom-error-display>
		</div>
		<div class="t-c-actions" nz-row>
			<div class="xs-wd-100" nz-col nzSpan="12">
				<app-custom-button text="Back to Login" type="link" (click)="backToLogin()"></app-custom-button>
			</div>
			<div class="xs-wd-100" nz-col nzSpan="12">
				<app-custom-button [isDisabled]="!accept" [isSubmitting]="isSubmitting" (click)="goToDashboard()"
					text="Proceed to Dashboard" type="primary"></app-custom-button>
			</div>
		</div>
	</div>

</div>